export const projects = [
  {
    img: "https://thebrandreality.com/wp-content/uploads/2022/05/The-BR-Blog-Banners-9.png",
    title: "Coschedule-Clone",
    des: "CoSchedule is the marketing industry's leading provider of content calendar, content optimization and marketing education products. This was a collaborative project buit by team of 5 members in 5 days.",
    
    demo: "",
    live: " https://coschedulesite.netlify.app/",
    gitHub: "https://github.com/sangle2022/ripe-receipt-7221",
    technologies: ["HTML", "CSS", "JavaScript","React", "Chakra UI"],
  },
  {
    img: "https://techstory.in/wp-content/uploads/2015/01/FabBag.jpg",
    title: "Fab-Bag-Clone",
    des: "This is a team project where we cloned most of the pages of fabbag.com website. FAB BAG is India's first & largest beauty-subscription company.",
    demo: "",
    live: "https://inquisitive-stroopwafel-9ad963.netlify.app/",
    gitHub: "https://github.com/sangle2022/fabbag-new-final",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      
    ],
  },
  {
    img: "https://ankitchaurasia.netlify.app/images/portfolio/modals/shop.PNG",
    title: "Shop.com-Clone",
    des: "This is a team project where we cloned most of the pages of shop.com website. Shop.com is an e-commerce website from where one can buy clothing and beauty related products.",
    demo: "",
    live: "https://stunning-gecko-ff6621.netlify.app/",
    gitHub: "https://github.com/sangle2022/Shop.com-clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      
    ],
  }];
